// Generated by CoffeeScript 2.7.0
var AssignmentMixin;

export default AssignmentMixin = {
  props: {
    assignment: Skylark.App.Model.YetAnotherWorkflow.Assignment,
    currentVertex: Object
  },
  data: function() {
    return {
      comment: ''
    };
  },
  computed: {
    commentFieldClass: function() {
      return {
        required: _.some(this.currentVertex.settings.comment_present, function(value) {
          return value;
        })
      };
    },
    placeholderText: function() {
      var txt;
      txt = _.reduce(this.currentVertex.settings.comment_present, function(acc, item, key) {
        if (item) {
          acc.push(`${Skylark.Helpers.t('assignment.operates.' + key)}时`);
        }
        return acc;
      }, []);
      if (txt.length > 0) {
        return `${txt.join('、')}需必填`;
      } else {
        return '请输入';
      }
    }
  },
  methods: {
    getRequestData: function(validate_required) {
      var response_data;
      if (this.$refs.responseRef) {
        response_data = this.$refs.responseRef.getResponse(validate_required);
        if (!response_data) {
          return;
        }
        return {
          response_attributes: response_data
        };
      } else {
        return {
          response_attributes: {}
        };
      }
    },
    updateAssignmentReponse: function(response) {
      var ref;
      return (ref = this.$refs.responseRef) != null ? ref.updateResponse(response) : void 0;
    },
    getCommentData: function() {
      return this.comment;
    }
  }
};
